import { render } from "./WorkPositionsPage.vue?vue&type=template&id=648616d7"
import script from "./WorkPositionsPage.vue?vue&type=script&lang=js"
export * from "./WorkPositionsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__